module.exports = __webpack_public_path__ + "static/media/soono_FF-02.3f287239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/soono_FF-02.png
// module id = 304
// module chunks = 0